import styled from 'styled-components';

export const MainContainer = styled.div`
  display: flex;
  flex-direction: column;
  background-color: ${({ embedded }) => (embedded ? 'transparent' : '#e5f1fc')};
  min-height: ${({ embedded }) => (embedded ? 'auto' : '100vh')};
  width: 100%;
  position: relative;
  background-repeat: no-repeat;
  background-size: cover;
  background-position: center;
  overflow: hidden;

  * {
    font-family: 'Poppins', sans-serif;
  }

  /* Ensure background covers the entire scrollable area - only for standalone */
  ${({ embedded }) =>
    !embedded &&
    `
    &::before {
      content: '';
      position: fixed;
      top: 0;
      left: 0;
      width: 100%;
      height: 100%;
      z-index: -1;
    }
  `}
`;

export const PreviewContainer = styled.div`
  max-width: 866px;
  background: white;
  border-radius: 10px;
  border: 1px #e0e0e0;
  padding: 16px;
  position: relative;
  z-index: 1;
  height: fit-content;
  overflow: auto;
  box-shadow: ${({ embedded }) =>
    embedded ? '0 2px 8px rgba(0, 0, 0, 0.1);' : 'none'};

  @media screen and (min-width: 525px) {
    padding: 16px 60px;
  }

  @media screen and (min-width: 769px) {
    margin: 32px auto 0 auto;
  }

  @media screen and (min-width: 1440px) {
    max-width: 950px;
  }
`;
